module.exports = __webpack_public_path__ + "img/kws.a1c53a73.svg";